import {
  Block,
  InfoCircle,
  Link,
  ListItem,
  ListItemLabel,
  ParagraphLarge,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { links } from "#/shared/constants"

export default function AssetsBridgingSummary() {
  const [css, theme] = useStyletron()

  return (
    <Block>
      <ParagraphLarge
        marginBottom={theme.sizing.scale600}
        marginLeft={theme.sizing.scale600}
      >
        Bridging your assets to Mainnet
      </ParagraphLarge>
      <Block as="ul">
        {[
          {
            id: 1,
            label:
              "When the lock period for your deposited funds expires, your assets with auto-bridge function enabled will automatically bridge to Mezo Mainnet.",
          },
          {
            id: 2,
            label:
              "All deposits will be bridged automatically if you stay opted in.",
          },
          {
            id: 3,
            label:
              "All migrations will happen seamlessly with no additional steps required.",
          },
        ].map(({ id, label }) => (
          <ListItem
            key={id}
            overrides={{
              Root: {
                props: {
                  className: "asset-bridging-summary-list",
                },
                style: ({ $theme }) => ({
                  background: "transparent",
                  display: "list-item",
                  listStyleType: "disc",
                  overflow: "visible",
                  width: "unset",
                  marginLeft: $theme.sizing.scale900,
                  "li.asset-bridging-summary-list::marker": {
                    color: $theme.colors.contentSecondary,
                  },
                }),
              },
              Content: {
                style: () => ({
                  marginLeft: 0,
                  border: "none",
                }),
              },
            }}
          >
            <ListItemLabel
              overrides={{
                LabelContent: {
                  component: ParagraphSmall,
                  style: ({ $theme }) => ({
                    color: $theme.colors.contentSecondary,
                  }),
                },
              }}
            >
              {label}
            </ListItemLabel>
          </ListItem>
        ))}
        <ListItem
          artwork={() => (
            <InfoCircle
              color={theme.colors.contentPrimary}
              size={theme.sizing.scale600}
            />
          )}
          overrides={{
            Root: {
              style: () => ({
                background: "transparent",
              }),
            },
            Content: {
              style: () => ({
                border: "none",
              }),
            },
          }}
        >
          <ListItemLabel
            overrides={{ LabelContent: { props: { $as: "div" } } }}
          >
            <ParagraphSmall color={theme.colors.contentSecondary}>
              <ParagraphSmall
                as="span"
                color={theme.colors.contentSecondary}
                style={{
                  fontWeight: "700",
                }}
              >
                Important:
              </ParagraphSmall>{" "}
              All deposit-related mats rewards will stop on Mainnet launch. To
              activate your earned mats on Mainnet, your assets must be bridged
              to Mezo. Keeping auto-bridge enabled ensures this happens
              smoothly. If you opt-out, you can still manually bridge your
              assets later to activate your mats.{" "}
              <Link
                href={links.MEZO_MAINNET_IS_COMING}
                target="_blank"
                className={css({
                  color: theme.colors.contentSecondary,
                  textDecorationColor: theme.colors.contentSecondary,
                })}
              >
                <ParagraphSmall as="span" color={theme.colors.contentSecondary}>
                  Read more
                </ParagraphSmall>
              </Link>{" "}
              on Mezo Mainnet launch.
            </ParagraphSmall>
          </ListItemLabel>
        </ListItem>
      </Block>
    </Block>
  )
}
